import { useState } from "react";
import { Sparkles, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TRY_ROLES } from "@/components/try/TryRoleSelect";

export default function TryModeSelect({ role, onBack, onBegin }) {
  const [mode, setMode] = useState("guided");
  const roleLabel = TRY_ROLES.find((r) => r.id === role)?.label || "Visitor";

  return (
    <div className="w-full max-w-lg mx-auto text-center relative z-10" data-testid="try-mode-select">
      <p className="text-sm mb-2 font-semibold uppercase tracking-wide" style={{ color: "rgba(176, 219, 255, 0.75)" }}>
        Showing around: {roleLabel}
      </p>
      <h2 className="font-display text-3xl font-bold text-white mb-8">How would you like to explore?</h2>

      <div className="flex flex-col gap-4 mb-8">
        <button
          onClick={() => setMode("guided")}
          data-testid="try-mode-guided"
          className={`text-left p-5 rounded-2xl border-2 transition-all flex items-start gap-4 ${
            mode === "guided" ? "border-sky-400 bg-sky-500/15" : "border-white/15 bg-white/5 hover:bg-white/10"
          }`}
        >
          <Sparkles className="w-6 h-6 text-sky-300 shrink-0 mt-0.5" />
          <div>
            <div className="font-display font-semibold text-white">Guided Demo <span className="text-xs font-normal text-sky-300">(recommended)</span></div>
            <div className="text-sm mt-1" style={{ color: "rgba(176, 219, 255, 0.8)" }}>
              We walk you through 3 topics across subjects, in sequence
            </div>
          </div>
        </button>

        <button
          onClick={() => setMode("free")}
          data-testid="try-mode-free"
          className={`text-left p-5 rounded-2xl border-2 transition-all flex items-start gap-4 ${
            mode === "free" ? "border-sky-400 bg-sky-500/15" : "border-white/15 bg-white/5 hover:bg-white/10"
          }`}
        >
          <Compass className="w-6 h-6 text-sky-300 shrink-0 mt-0.5" />
          <div>
            <div className="font-display font-semibold text-white">Free Explore</div>
            <div className="text-sm mt-1" style={{ color: "rgba(176, 219, 255, 0.8)" }}>
              Pick any topic yourself from the grid
            </div>
          </div>
        </button>
      </div>

      <Button
        onClick={() => onBegin(mode)}
        data-testid="try-begin-btn"
        className="w-full py-4 rounded-2xl text-base font-semibold bg-sky-500 hover:bg-sky-600 text-white shadow-md hover:shadow-lg transition-all"
      >
        Begin
      </Button>

      <button
        onClick={onBack}
        data-testid="try-mode-back-btn"
        className="mt-5 inline-flex items-center justify-center gap-1.5 text-sm hover:opacity-90 transition-colors"
        style={{ color: "rgba(176, 219, 255, 0.85)" }}
      >
        ← Go back
      </button>
    </div>
  );
}
